
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/data",
      function () {
        return require("private-next-pages/settings/data.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/data"])
      });
    }
  